module.exports = __webpack_public_path__ + "img/img4.7217d1b6.png";